export const sortByPositionField = <T>(
  data: ({ posit?: string } & T)[]
): ({ posit?: string } & T)[] => {
  if (!Array.isArray(data)) return data;
  return data.sort(({ posit = "" }, { posit: positB = "" }) =>
    posit > positB ? -1 : posit < positB ? 1 : 0
  );
};
